import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import SpacingBox from "./Spacing";
import HeadingPage from "./Heading";
import AudioPlayer from "./AudioPlayer";
import MCQQuestion from "./Mcq";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useFetchData from "../fetchpostData";
import Notification from "./Notification";
import ScoreBoxForReading from "./ResponseBoxReadingSection";
import ScoreCardForReading from "./ScoreBoxForReadingSection";
import Timers from "../PageComponent/Timers";
import Timer from "../MockTest/Timer";

export default function SelectMissingWordsPage() {
  const { title } = useParams();

  // Fix later
  const section = "missingword";
  const practiceItemId = title;

  const post = useFetchData(section, title); // Use the hook
  const [originalWords, setOriginalWords] = useState("");
  const [Title, setTitle] = useState("");
  const [audioLink, setaudioLink] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [McqOptions, setMcqOptions] = useState("");

  const [paraTitle, setParaTitle] = useState("");

  const [selectedOption, setSelectedOption] = useState(null);
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [savedPractice, setSavedPractice] = useState(null); // New state to store saved practice data
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleOptionSelect = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  useEffect(() => {
    console.log("Selected Options ", selectedOption);
  }, [selectedOption]);

  useEffect(() => {
    console.log("Post Data :", post);

    if (post && post.media_link) {
      setOriginalWords(post.question);
      setTitle(post.q_title);
      setMcqOptions(post.option);
      setMcq_Question(post.question_mcq);

        // Extract file name from media_link
        const fileName = encodeURIComponent(post.media_link.split("/").pop());
  
        // Fetch the signed URL from the backend
        fetch(`/ptedata/ptemedia/${fileName}`, { credentials: "include" }) // Ensure cookies/session are sent
          .then((response) => response.json())
          .then((data) => {
            if (data.url) {
             setaudioLink(data.url); // Set the signed URL as the image source
            } else {
              console.error("Failed to fetch image URL");
            }
          })
          .catch((error) => console.error("Error fetching signed URL:", error));
    }
  }, [post]);

  console.log("Audio Link:", audioLink);
  console.log("Original Word:", originalWords);

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-selectmissingword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitted(true);

    const practiceType = section;
    const isCorrect = McqOptions.some(
      (option) => option.options === selectedOption && option.correct === 1
    );

    const practiceData = {
      practiceType,
      practiceItemId,
      response: {
        questionId: practiceItemId,
        answer: selectedOption,
        isAttempted,
      },
    };

    console.log("practiceData:", practiceData);
    try {
      const result = await savePractice(practiceData);
      console.log("Practice data saved:", result);
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setSavedPractice(result);
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error("Error saving practice data:", error);
      setMessage("Failed to save practice data.");
      setNotificationType("error");
      setShowNotification(true); // Show notification
      setLoading(false);
    }
  };

  const handleRetake = () => {
    setSelectedOption(null);
    setSubmitted(false);
    setIsAttempted(false);
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  console.log("savedPractice", savedPractice);

  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";
  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title={Title}
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={attemptedStatus}
          para="You will hear a recording about Faint Sound. At the end of the recording the last word or group of words has benn replaced by a beep. Select the correct option to complete the recording

"
        />

        {audioLink && <AudioPlayer audioSrc={audioLink} />}

        <div className="font-bold p-2 pt-4 text-center md:text-right md:ml-[1000px]"><Timer initialMinutes={10} initialSeconds={0} Text="Time Remaining" /></div>
        <MCQQuestion
          question={Mcq_Question}
          options={McqOptions}
          onOptionSelect={handleOptionSelect}
          selectedOption={selectedOption}
          submitted={submitted}
        />
        <div className="flex space-x-4 mt-4">
          <button
            className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-1 px-4 ml-5 rounded-sm"
            onClick={handleSubmit}
            disabled={submitted}
          >
            <span className="flex items-center justify-center">
              {loading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Submitting...</span>
                </>
              ) : (
                "Submit"
              )}
            </span>
          </button>

          {submitted && (
            <button
              type="button"
              onClick={handleRetake}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-1 px-4 rounded-sm"
            >
              Retake
            </button>
          )}
        </div>
        {submitted ? (
          <>
            <div className="flex items-center justify-center h-72 bg-gray-100">
              <ScoreCardForReading
                score={savedPractice?.savedResponse.totalScore}
                maxScore={1}
              />{" "}
            </div>
          </>
        ) : null}
        <ScoreBoxForReading
          originalWords={originalWords}
          practiceItemId={practiceItemId}
          onIsAttempted={handleIsAttempted}
        />
        {showNotification && (
          <Notification
            message={message}
            type={notificationType}
            onClose={handleCloseNotification}
          />
        )}
        <SpacingBox />
      </div>
    </div>
  );
}
